import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { ViewWrapperVideo, Video } from 'libs/rendering/styles';

export const VideoViewer = observer(function _VideoViewer({
  file,
  isPreview,
  width,
}) {
  const err = `Your browser doesn&#39;t support ${file?.mimeType} videos.`;

  return (
    <ViewWrapperVideo
      isPreview={isPreview}
      itemscope
      itemtype='http://schema.org/VideoObject'
      width={width}
    >
      <meta itemProp='contentUrl' content={file?.permalink}></meta>
      <meta itemProp='encodingFormat' content={file?.mimeType}></meta>
      <Video controls>
        <source src={file?.permalink} />
        {err}
      </Video>
    </ViewWrapperVideo>
  );
});

VideoViewer.propTypes = {
  file: PropTypes.object,
  isPreview: PropTypes.bool,
  chatControl: PropTypes.object,
};
